import {
  RECEIVED_PRINTER_LIST, ERROR_ON_GETTING_PRINTER_LIST, START_FETCHING_PRINTER_LIST, UPDATE_PRINTER_STATE,
  UPDATE_TOGGLE_LIST_OF_PRINTER_STATUS,
} from "./types";
import axios from 'axios';
import {backendDomain} from "../modules/configs";

export const getPrinterList = () => dispatch => {
  dispatch({ type: START_FETCHING_PRINTER_LIST });
  // return value of thunk will become return value of the dispatcher of this thunk
  return axios.get(`${backendDomain}/query/printers`, { headers: { Authorization: `Bearer ${localStorage.access_token}` } }).then(req => {
    // Defaults
    const printers = req.data;
    const printerIds = [];
    const printerState = {}; // state mapping: printerId -> state
    printers.forEach(printer => {
      const printerId = printer.printerId;
      printerState[printerId] = {
        printerName: 'N/A',
        status: 'offline',
        timeElapsed: 0,
        timeLeft: 0,
        isPaused: true,
        jobData: {
          layerThickness: 0,
          resinColor: 'N/A'
        }
      };
      printerIds.push(printerId);
    })
    dispatch(updatePrinterState(printerState));
    dispatch(receivedPrinterList(printerIds));
  })
    .catch(err => {
      dispatch(errorOnGettingPrinterList(err));
    })
}

const receivedPrinterList = printerIds => ({
  type: RECEIVED_PRINTER_LIST,
  payload: { printerIds }
})

const errorOnGettingPrinterList = error => ({
  type: ERROR_ON_GETTING_PRINTER_LIST,
  payload: { error }
})

export const updatePrinterState = printerState => ({
  type: UPDATE_PRINTER_STATE,
  payload: { ...printerState }
})

export const updateToggleListOfPrinterStatus = togglesOfPrinterStatusItems => ({
  type: UPDATE_TOGGLE_LIST_OF_PRINTER_STATUS,
  payload: { togglesOfPrinterStatusItems }
})


// WEBPACK FOOTER //
// ./src/actions/getPrinterStatus.js